import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Typography,
  InputAdornment,
  CircularProgress,
  Box,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import { surgeryPrimaryOderMenuItems } from "../../utils/data";
import { ReactComponent as AddIcon } from "../../Assets/Icons/AddIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/CloseIcon.svg";
import {
  RESET_SURGERY_STATE,
  START_CREATE_SURGERY,
  START_UPDATE_SURGERY,
  START_GET_SINGLE_SURGERY,
  START_WORKING_DAY_LIST,
} from "../../Actions/SurgeryAction";
import { START_CREATE_PATIENT_SURGERY } from "../../Actions/PatientAction";
import { connect, useSelector } from "react-redux";
import * as yup from "yup";
import { useFormik } from "formik";
import "../../Sass/Common.scss";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import DriverAutoComplete from "../../Components/Surgery/DriverAutoComplete";
import AutoCompleteTextField from "../../Components/Common/AutoCompleteTextField";
import PharmacyAutoComplete from "../../Components/Patients/PharmacyAutoComplete";
import { START_GET_STAFF_LIST } from "../../Actions/StaffAction";
import { START_GET_HOME_LIST } from "../../Actions/HomeAction";
import SubscriptionWaringDailog from "../../Components/Common/Dialog/SubscriptionWaringDailog";
import { ReactComponent as NoteTextIcon } from "../../Assets/Icons/NoteTextcon.svg";
import clsx from "clsx";
import useViewport from "Hooks/useViewport";
const useStyle = makeStyles((theme) => ({
  rsSurgeriesAddNoteBtn: {
    float: "right",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      paddingRight: 0,
    },
    "& .MuiInputAdornment-root ": {
      backgroundColor: theme.palette.background.red,
      padding: "19px 14px",
      borderRadius: "0px 5px 5px 0px",
      cursor: "pointer",
    },
  },
  Removeborder: {
    marginBottom: "40px !important",
  },
  formWrapper: {
    position: "relative",
    "& > span": {
      position: "absolute",
      top: "35%",
      left: "46%",
      transform: "translate(-50%, -50%)",
      zIndex: 1,
    },
  },
  weeksLable: {
    "&>span": {
      fontSize: "14px !important",
      fontWeight: "400 !important",
    },
  },
  paddingMain: {
    paddingTop: "20px !important",
  },
  paddingMain5: {
    paddingTop: "10px !important",
  },
  Padding: {
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
  },
  submitButton: {
    height: "48px !important",
  },
  gridContainer: {
    display: "flex",
    flexDirection: "column !important",
  },
  gridItem: {
    display: "flex",
    [theme.breakpoints.down("800")]: {
      flexDirection: "column !important",
    },
    "&>div:nth-child(1)": {
      marginRight: "20px",
      [theme.breakpoints.down("800")]: {
        flexDirection: "column !important",
        marginRight: "0px",
      },
    },
    "&:nth-of-type(4)": {
      "&>div:nth-child(1)": {
        maxWidth: "412px",
        [theme.breakpoints.down("800")]: {
          maxWidth: "unset",
        },
      },
    },
  },
}));

const CreateSurgeryDialog = (props) => {
  const {
    open,
    setOpen,
    editData,
    setEditData,
    surgeryRecordActionType,
    createSurgeryAction,
    createSurgeryData,
    updateSurgeryAction,
    updateSurgeryData,
    getSingleSurgeryAction,
    resetSurgeryState,
    singleSurgery,
    getWorkingDayAction,
    workingDayList,
    createPatientSurgeryAction,
    createPatientSurgeryData,
    resetPatientState,
    callBackOnSubmitSurgeryInfo,
    getStaffListAction,
    getList,
    col,
    setCol,
    getHomeListAction,
  } = props;
  const classes = useStyle();
  const [notesArray, setNotesArray] = useState([]);
  const workingDayRecordLimit = 20;
  const [isOpenOrderList, setIsOpenOrderList] = useState(false);
  const formState = {
    surgery_name: "",
    email: "",
    ordering_method: "",
    address: "",
    notes: "",
    driver_ids: [],
    driver_goes_days: [],
    phone: "",
    fax: "",
    pharmacy_info: {},
    pharmacy_id: "",
  };
  const [surgeryData, setSurgeryData] = useState(formState);
  const [deleteNote, setDeleteNote] = useState([]);
  const blankNotes = notesArray.filter((item) => {
    return item?.notes?.trim() === "";
  });
  const loginUserDetail = useSelector((state) => state.user);
  const [isOpenPharmacyAutocomplete, setIsOpenPharmacyAutocomplete] =
    useState(false);
  const PharmacyRef = useRef(null);
  const showDataBasedOnRole =
    loginUserDetail?.loginUserDetail?.data?.data?.role;
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const width = useViewport();
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const faxReGExp = /^\+?[0-9]{6,}$/;
  const query = new URLSearchParams(window.location.search);
  const location = useLocation();
  /* Other Validation Schema */
  const surgerySchema = yup.object().shape({
    surgery_name: yup
      .string()
      .required("The full name field is required.")
      .matches(
        /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,~`.<>\/?  ]*$/,
        "Please enter valid  name"
      ),
    email: yup
      .string()
      .matches(
        /^[a-zA-Z0-9+_.-]+@nhs.net|nhs.uk|@gp.hscni.net|@yopmail.com|@health.gg|@healthcare.gg|@eqrmp.com|@channelislands.coop|@nhs.scot+$/,
        "The  email should be valid"
      ),
    // email: yup.string().email("The  email should be valid"),
    // address: yup.string().required("The surgery  address field is required."),
    ordering_method: yup.string(),
    // .required("The  ordering method field is required."),
    phone: yup
      .string()
      // .required("The  phone number field is required.")
      .matches(phoneRegExp, "Phone  number is not valid")
      .max(13, "The  phone number should be between 10 to 13 digits."),
    fax: yup.string().matches(faxReGExp, "Fax  number is not valid"),
    // postcode: yup
    //   .string()
    //   .matches(/^[A-Z0-9 ]*$/, "Please enter valid  postCode"),
  });
  /* Handle Surgery add main Function */
  const handleAddSurgery = (formValues) => {
    // if (loginUserDetail?.loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {

    if (query.get("actionType") === null) {
      setCol("action");
    }
    const payload = {
      name: formValues?.surgery_name,
      email: formValues?.email,
      address: formValues?.address,
      // postcode: formValues?.postcode,
      // ordering_method: formValues?.ordering_method,
      driver_ids: Object.keys(formValues?.driver_ids),
      driver_goes_days: formValues?.driver_goes_days,
      phone: formValues?.phone,
      fax: formValues?.fax,
    };
    if (surgeryRecordActionType === "createNewSurgery") {
      payload.ordering_method = formValues?.ordering_method;
    }
    if (surgeryRecordActionType === "editSurgeryDetail") {
      payload.ordering_method = formValues?.ordering_method
        ? formValues?.ordering_method
        : "";
    }

    if (formValues.fax?.length > 0) {
      payload.fax = formValues.fax;
    }
    if (formValues.phone?.length > 0) {
      payload.phone = formValues.phone;
    }

    //Start code for new notes
    const filletedNotes = notesArray.filter((item) => {
      if (item.hasOwnProperty("id") === false) {
        return item.notes !== "";
      }
    });
    if (filletedNotes.length > 0) {
      payload.notes = filletedNotes.map((item) => {
        return item.notes;
      });
    }

    if (showDataBasedOnRole === "super_admin") {
      payload.pharmacy_id = formValues?.pharmacy_id;
    }
    //Update note payload
    if (surgeryRecordActionType === "editSurgeryDetail") {
      const updateNoteMapping = notesArray
        .filter((item) => {
          if (item.hasOwnProperty("id") === true) {
            return item.notes !== "";
          }
        })
        ?.map((item) => {
          return {
            id: item.id,
            notes: item.notes,
          };
        });
      if (updateNoteMapping?.length > 0) {
        payload.update_notes = updateNoteMapping;
      }
      if (notesArray?.length === 1) {
        let temp = notesArray?.map((item) => {
          if (item.notes === "") {
            if (item.id) {
              payload.delete_notes = [item.id];
            }
          }
        });
      }

      if (deleteNote.length > 0) {
        payload.delete_notes = deleteNote;
      }
    }

    if (
      surgeryRecordActionType === "editSurgeryDetail" &&
      Object.keys(singleSurgery)?.length > 0
    ) {
      updateSurgeryAction(editData?.id, payload);
    } else if (surgeryRecordActionType === "createNewSurgery") {
      createSurgeryAction(payload);
    } else {
      payload.ordering_method = formValues?.ordering_method;
      createPatientSurgeryAction(payload);
    }
    // }
  };
  useEffect(() => {
    if (open && surgeryRecordActionType === "createNewSurgery") {
      setTimeout(() => {
        document.getElementById("surgery_name")?.focus();
      }, 500);
    }
    if (open && surgeryRecordActionType === "patientInfo") {
      setTimeout(() => {
        document.getElementById("surgery_name")?.focus();
      }, 500);
    }
  }, [open]);

  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    handleBlur,
    resetForm,
    setErrors,
    setFieldValue,
  } = useFormik({
    initialValues: surgeryData,
    validationSchema: surgerySchema,
    enableReinitialize: true,
    onSubmit: handleAddSurgery,
  });

  const handleClose = () => {
    setOpen(false);
    setSurgeryData({
      ...formState,
    });
    if (surgeryRecordActionType === "editSurgeryDetail") {
      setEditData({});
    }
    setDeleteNote([]);
    setNotesArray([]);
    resetForm();
    resetSurgeryState("createSurgeryData");
    resetSurgeryState("updateSurgeryData");
    resetSurgeryState("singleSurgery");
    resetPatientState("createPatientSurgeryData");
  };

  /* Edit api call useEffect */
  useEffect(() => {
    if (open) {
      console.log(workingDayList?.data?.list?.length, "workingDayList");

      if (workingDayList?.data?.list?.length == undefined) {
        getWorkingDayAction({ offset: 0, limit: workingDayRecordLimit });
      }
      if (
        surgeryRecordActionType === "editSurgeryDetail" &&
        Object.keys(singleSurgery)?.length > 0
      ) {
        getSingleSurgeryAction(editData.id);
      } else {
        setNotesArray(
          notesArray.concat([
            {
              notes: "",
            },
          ])
        );
      }
    } else {
      setSurgeryData(formState);
    }
  }, [open]);

  /* Working Day Api useEffect */
  // useEffect(() => {
  //   if (
  //     !workingDayList?.loading &&
  //     !Object.keys(workingDayList?.data)?.length &&
  //     location.pathname !== "/order"
  //   ) {
  //     getWorkingDayAction({ offset: 0, limit: workingDayRecordLimit });
  //   }
  // }, [workingDayList]);

  /* Create & update loading useEffect */
  useEffect(() => {
    if (col === "action") {
      if (
        (surgeryRecordActionType === "createNewSurgery" &&
          !createSurgeryData?.loading &&
          Object.keys(createSurgeryData?.data || {})?.length > 0) ||
        (surgeryRecordActionType === "editSurgeryDetail" &&
          !updateSurgeryData?.loading &&
          Object.keys(updateSurgeryData?.data || {})?.length > 0) ||
        (surgeryRecordActionType === "patientInfo" &&
          !createPatientSurgeryData?.loading &&
          Object.keys(createPatientSurgeryData?.data || {})?.length > 0)
      ) {
        resetSurgeryState("createSurgeryData", "");
        resetSurgeryState("updateSurgeryData", "");
        resetPatientState("createPatientSurgeryData");
        handleClose();
      }
    }
  }, [createSurgeryData, updateSurgeryData, createPatientSurgeryData]);

  /* Create surgery success useEffect */
  useEffect(() => {
    let payload = {};
    if (createPatientSurgeryData?.data?.success) {
      callBackOnSubmitSurgeryInfo(createPatientSurgeryData?.data);
      // getList();
      handleClose();
      getHomeListAction(payload);
    }
  }, [createPatientSurgeryData?.data?.success]);

  useEffect(() => {
    let payload = {};
    if (
      (createSurgeryData?.data?.success || updateSurgeryData?.data?.success) &&
      col === "action"
    ) {
      let payload = {
        offset: 0,
      };
      getList();
      // getStaffListAction(payload);
      handleClose();
      // getHomeListAction(payload);
    }
  }, [createSurgeryData?.data?.success, updateSurgeryData?.data?.success]);

  /* Create & update surgery error useEffect  */
  useEffect(() => {
    const errors =
      surgeryRecordActionType === "createNewSurgery"
        ? createSurgeryData?.error?.errors
        : surgeryRecordActionType === "editSurgeryDetail"
        ? updateSurgeryData?.error?.errors
        : createPatientSurgeryData?.error?.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[0];
        return item;
      });
      setErrors(obj);
    }
  }, [
    createSurgeryData?.error,
    updateSurgeryData.error,
    createPatientSurgeryData?.error,
  ]);

  /* Edit info get useEffect */
  useEffect(() => {
    if (
      surgeryRecordActionType === "editSurgeryDetail" &&
      Object.keys(singleSurgery?.data)?.length > 0
    ) {
      const primaryOrderMethodData = surgeryPrimaryOderMenuItems.filter(
        (item, index) => {
          return item.value === singleSurgery?.data?.ordering_method;
        }
      );

      let notes = [
        {
          notes: "",
        },
      ];
      if (singleSurgery?.data?.notes?.length > 0) {
        notes = singleSurgery?.data?.notes?.map((value) => {
          return {
            id: value.id,
            notes: value.notes,
          };
        });
      }

      let newList = [];
      singleSurgery?.data?.driver?.map((driver) => {
        newList[driver.sd_driver_id] = {
          ...driver,
          id: driver.sd_driver_id,
        };
      });
      const newWorkingDayList = singleSurgery?.data?.driver_goes_days?.map(
        (workingDay) => {
          return workingDay.sdwd_wd_id;
        }
      );
      setNotesArray(notes);
      setSurgeryData({
        surgery_name: singleSurgery?.data?.name || "",
        email: singleSurgery?.data?.email || "",
        address: singleSurgery?.data?.address || "",
        // postcode: singleSurgery?.data?.postcode || "",
        ordering_method: primaryOrderMethodData[0]?.value || "",
        notes: notes,
        driver_ids: newList,
        driver_goes_days: newWorkingDayList,
        phone: singleSurgery?.data?.phone || "",
        fax: singleSurgery?.data?.fax || "",
        pharmacy_id: singleSurgery?.data?.pharmacy_detail?.id || "",
        pharmacy_info: singleSurgery?.data?.pharmacy_detail || "",
      });
    }
  }, [singleSurgery?.data]);

  /* Handle Click add black note */
  const handleClickAddNote = () => {
    setNotesArray(
      notesArray.concat([
        {
          notes: "",
        },
      ])
    );
  };

  /* Handle Click remove note */
  const handleClickRemoveNote = (removeIndex) => {
    if (notesArray[removeIndex].hasOwnProperty("id")) {
      setDeleteNote([...deleteNote, notesArray[removeIndex].id]);
    }
    const newData = notesArray.filter((item, index) => index !== removeIndex);

    setNotesArray(newData);
  };

  /* Handle click  note changes */
  const handleNoteChange = (e, index, rowInfo) => {
    const allNotes = notesArray;
    allNotes[index] = {
      ...allNotes[index],
      notes: e.target.value,
    };
    setNotesArray([...allNotes]);
  };

  /* Return server error */
  const returnServerError = (errorKey) => {
    let errorObj = {
      keyPresent: false,
      message: "",
    };
    let errorBag =
      surgeryRecordActionType === "createNewSurgery"
        ? createSurgeryData?.error?.errors
        : surgeryRecordActionType === "editSurgeryDetail"
        ? updateSurgeryData?.error?.errors
        : createPatientSurgeryData?.error?.errors;
    if (errorBag?.hasOwnProperty(errorKey)) {
      errorObj = {
        keyPresent: true,
        message: errorBag?.[errorKey]?.[0],
      };
    }
    return errorObj;
  };

  /* Remove Server error */
  const removeServerError = (errorKey) => {
    if (returnServerError(errorKey).keyPresent) {
      let reducer = updateSurgeryData;
      let actionName = "updateSurgeryData";
      if (surgeryRecordActionType === "createNewSurgery") {
        reducer = createSurgeryData;
        actionName = "createSurgeryData";
      } else if (surgeryRecordActionType === "patientInfo") {
        reducer = createPatientSurgeryData;
        actionName = "createPatientSurgeryData";
      }

      const _errorBag = reducer["error"]["errors"];
      //Remove particular key
      delete _errorBag[errorKey];
      const updateState = {
        ...reducer,
        error: {
          ...reducer.error,
          errors: _errorBag || {},
        },
      };
      resetSurgeryState(actionName, updateState);
    }
  };

  /* Selection order method */
  const selectedOrderMethodOption = () => {
    if (values?.ordering_method !== "") {
      const option = surgeryPrimaryOderMenuItems.filter((item) => {
        return item.value === values?.ordering_method;
      });
      if (option.length > 0) {
        return option[0].label;
      }
    }
    return "";
  };

  return (
    <>
      <Dialog
        className={clsx("RSxs_modal", classes.Removeborder)}
        open={open}
        maxWidth={"md"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        // className="rsDialogMain"
      >
        <Box className={classes.formWrapper}>
          <Box className="ModalHeading default_form">
            <Box
              className="ModalIconWidth"
              textAlign={"center"}
              justifyContent={"center"}
            >
              <Box className="ModalTitleView">
                <PrimaryDialogTitle
                  icon={NoteTextIcon}
                  handleClose={handleClose}
                  title={
                    surgeryRecordActionType === "createNewSurgery"
                      ? "Create New Surgery"
                      : surgeryRecordActionType === "editSurgeryDetail"
                      ? "Edit Surgery"
                      : "Create Surgery"
                  }
                  surgerycreate
                />
              </Box>
            </Box>
          </Box>
          {surgeryRecordActionType === "editSurgeryDetail" &&
            singleSurgery.loading && (
              <CircularProgress color="primary" size="51px" />
            )}
          <Box className="rsNoteGrid">
            <form
              name="registration"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
                var name = document?.registration?.name?.value;
                var ordering_method =
                  document?.registration?.ordering_method?.value;
                // var phone = document?.registration?.phone?.value;
                const firstError = Object.keys(errors).reduce((field, a) => {
                  return !!errors[field] ? field : a;
                }, null);
                if (name === null || name === "") {
                  document.getElementById("surgery_name")?.focus();
                } else if (firstError === "name") {
                  document.getElementById("surgery_name")?.focus();
                }
                //  else if (ordering_method === null || ordering_method === "") {
                //   setIsOpenOrderList(true);
                //   document.getElementById("ordering_method")?.focus();
                // }
                else if (firstError === "phone") {
                  document.getElementById("phone")?.focus();
                } else if (firstError === "address") {
                  document.getElementById("address")?.focus();
                }
                // else if (firstError === "postcode") {
                //   document.getElementById("postcode")?.focus();
                // }
              }}
            >
              <DialogContent className="DropdownDialogContent">
                <Grid
                  container
                  columnSpacing={1}
                  rowSpacing={3}
                  className={classes.Padding}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className={classes.gridContainer}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className={classes.gridItem}
                    >
                      <Grid
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        className={classes.paddingMain}
                      >
                        <TextField
                          variant="outlined"
                          fullWidth
                          placeholder="Full Name *"
                          label="Full Name *"
                          size="small"
                          id="surgery_name"
                          name="surgery_name"
                          value={values?.surgery_name}
                          onChange={(e) => {
                            handleChange(e);
                            removeServerError("name");
                          }}
                          onBlur={handleBlur}
                          error={
                            (touched?.surgery_name && errors?.surgery_name) ||
                            returnServerError("name").keyPresent
                          }
                          helperText={
                            (touched?.surgery_name && errors?.surgery_name) ||
                            returnServerError("name").message
                          }
                        />
                      </Grid>
                      <Grid
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        className={classes.paddingMain}
                      >
                        <AutoCompleteTextField
                          open={isOpenOrderList}
                          id="ordering_method"
                          name="ordering_method"
                          onOpen={() => {
                            setIsOpenOrderList(true);
                          }}
                          onClose={() => {
                            setIsOpenOrderList(false);
                          }}
                          options={surgeryPrimaryOderMenuItems}
                          value={values?.ordering_method || null}
                          inputValue={selectedOrderMethodOption()}
                          getOptionLabel={(option) => option?.label}
                          filterOptions={(option) => {
                            let result = [...option];
                            return result || [];
                          }}
                          onChange={(e, value) => {
                            setIsOpenOrderList(false);
                            setFieldValue("ordering_method", value?.value);
                            handleChange("ordering_method", value?.value);
                          }}
                          placeholder="Best Ordering Method "
                          label="Best Ordering Method "
                          error={
                            touched?.ordering_method && errors?.ordering_method
                          }
                          helperText={
                            touched?.ordering_method && errors?.ordering_method
                          }
                          onBlur={handleBlur}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className={classes.gridItem}
                    >
                      <Grid
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        className={classes.paddingMain}
                      >
                        <TextField
                          variant="outlined"
                          fullWidth
                          placeholder="Email Address"
                          label="Email Address"
                          size="small"
                          name="email"
                          value={values?.email}
                          error={
                            (touched?.email && errors?.email) ||
                            returnServerError("email").keyPresent
                          }
                          helperText={
                            (touched?.email && errors?.email) ||
                            returnServerError("email").message
                          }
                          onChange={(e) => {
                            handleChange(e);
                            removeServerError("email");
                          }}
                          onBlur={handleBlur}
                        />
                      </Grid>
                      <Grid
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        className={classes.paddingMain}
                      >
                        <TextField
                          variant="outlined"
                          fullWidth
                          placeholder="Phone Number "
                          label="Phone Number "
                          size="small"
                          id="phone"
                          name="phone"
                          value={values?.phone}
                          onChange={(e) => {
                            handleChange(e);
                            removeServerError("phone");
                          }}
                          onBlur={handleBlur}
                          error={
                            (touched?.phone && errors?.phone) ||
                            returnServerError("phone").keyPresent
                          }
                          helperText={
                            (touched?.phone && errors?.phone) ||
                            returnServerError("phone").message
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className={classes.gridItem}
                    >
                      <Grid
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        className={classes.paddingMain}
                      >
                        <TextField
                          variant="outlined"
                          fullWidth
                          placeholder="Fax Number"
                          label="Fax Number"
                          size="small"
                          name="fax"
                          value={values?.fax}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched?.fax && errors?.fax}
                          helperText={touched?.fax && errors?.fax}
                        />
                      </Grid>
                      <Grid
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        className={classes.paddingMain}
                      >
                        <TextField
                          variant="outlined"
                          fullWidth
                          placeholder="Surgery Address "
                          label="Surgery Address "
                          size="small"
                          id="address"
                          name="address"
                          value={values?.address}
                          error={touched?.address && errors?.address}
                          helperText={touched?.address && errors?.address}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className={classes.gridItem}
                    >
                      <Grid
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        className={classes.paddingMain}
                      >
                        <DriverAutoComplete
                          fullWidth
                          multiple
                          className={classes.autoCompleteBox}
                          value={values?.driver_ids}
                          onChange={(e, value) => {
                            let newList = [];
                            value.map((driver) => {
                              newList[driver.id] = driver;
                            });
                            setFieldValue("driver_ids", newList);
                            handleChange(e);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Which Driver Goes?"
                              label="Which Driver Goes?"
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Grid item xs={6} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Post Code "
                    label="Post Code "
                    size="small"
                    id="postcode"
                    name="postcode"
                    value={values?.postcode}
                    error={touched?.postcode && errors?.postcode}
                    helperText={touched?.postcode && errors?.postcode}
                    onChange={(e, value) => {
                      let temp = e.target.value.toUpperCase();
                      setFieldValue("postcode", temp);
                      // handleChange(e);
                    }}
                    // onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Grid> */}
                  {showDataBasedOnRole === "super_admin" && (
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      lg={6}
                      className={classes.paddingMain}
                      style={{ marginBottom: "10px" }}
                    >
                      <PharmacyAutoComplete
                        fullWidth
                        name="pharmacy_info"
                        id="pharmacy_info"
                        className={classes.autoCompleteBox}
                        value={values?.pharmacy_info}
                        onChange={(e, value) => {
                          setFieldValue("pharmacy_info", value);
                          setFieldValue("pharmacy_id", value?.id);
                        }}
                        isOpenPharmacyAutocomplete={isOpenPharmacyAutocomplete}
                        PharmacyRef={PharmacyRef}
                        onBlur={handleBlur}
                        renderInput={(params) => (
                          <TextField
                            inputRef={PharmacyRef}
                            {...params}
                            label="Pharmacy *"
                            placeholder="Pharmacy *"
                            name="pharmacy_info"
                            id="pharmacy_info"
                            error={touched?.pharmacy_id && errors?.pharmacy_id}
                            helperText={
                              touched?.pharmacy_id && errors?.pharmacy_id
                            }
                          />
                        )}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className={classes.paddingMain}
                  >
                    <Typography
                      color="Black"
                      regular
                      variant=""
                      display={"block"}
                      fontWeight={"600"}
                      fontSize={"18px"}
                      // color="secondary" regular variant="h4"
                    >
                      {/* On which days Driver goes? */}
                      On which days does driver go?
                    </Typography>
                    {workingDayList?.data?.list?.map((item, index) => {
                      return (
                        <FormControlLabel
                          className={classes.weeksLable}
                          key={index}
                          checked={
                            values?.driver_goes_days?.indexOf(item.wd_id) > -1
                          }
                          onChange={(e) => {
                            let driverGoesDay = values?.driver_goes_days;
                            const selectedDriverIndex = driverGoesDay.indexOf(
                              item?.wd_id
                            );
                            if (selectedDriverIndex === -1) {
                              driverGoesDay.push(item?.wd_id);
                            } else {
                              driverGoesDay.splice(selectedDriverIndex, 1);
                            }
                            setFieldValue(
                              "driver_goes_days",
                              Array.from(driverGoesDay)
                            );
                            handleChange(e);
                          }}
                          control={<Checkbox color="primary" />}
                          label={item?.wd_day}
                        />
                      );
                    })}
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    lg={6}
                    className="pdTop10 pdBottom"
                  >
                    <Typography
                      color="Black"
                      medium
                      variant=""
                      display={"block"}
                      fontWeight={"600"}
                      fontSize={"18px"}
                      // marginTop={"10px"}
                      // color="secondary" medium variant="h3"
                    >
                      Notes
                    </Typography>
                  </Grid>
                  {notesArray?.map((item, index) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        key={index}
                        className={classes.paddingMain5}
                      >
                        <TextField
                          fullWidth
                          className={classes.textField}
                          variant="outlined"
                          size="small"
                          placeholder="Add Note"
                          name={`notes[${index}]`}
                          id="outlined-adornment-weight"
                          aria-describedby="outlined-weight-helper-text"
                          value={item.notes}
                          onChange={(e) => {
                            handleChange(e);
                            handleNoteChange(e, index);
                          }}
                          error={touched?.notes && errors?.notes}
                          helperText={touched?.notes && errors?.notes}
                          onBlur={handleBlur}
                          inputProps={{
                            "aria-label": "weight",
                          }}
                          InputProps={{
                            endAdornment: (
                              // notesArray?.length > 1 ? (
                              <InputAdornment
                                position="end"
                                cursor={InputAdornment}
                                onClick={(e) => handleClickRemoveNote(index)}
                              >
                                <PrimaryIcon
                                  width="20px"
                                  icon={CloseIcon}
                                  color="white"
                                />
                              </InputAdornment>
                            ),
                            // ) : null,
                          }}
                        />
                      </Grid>
                    );
                  })}
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Button
                      variant="outlined"
                      className={clsx(
                        "BtnGreen",
                        classes.rsSurgeriesAddNoteBtn
                      )}
                      disabled={blankNotes.length > 0}
                      startIcon={
                        <PrimaryIcon
                          icon={AddIcon}
                          color="primary"
                          width="16px"
                          height="16px"
                        />
                      }
                      onClick={handleClickAddNote}
                    >
                      Add Note
                    </Button>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  className={clsx("BtnGreen", classes.submitButton)}
                  variant="contained"
                  type="submit"
                  disabled={
                    (surgeryRecordActionType === "createNewSurgery" &&
                      createSurgeryData?.loading) ||
                    (surgeryRecordActionType === "editSurgeryDetail" &&
                      updateSurgeryData?.loading) ||
                    singleSurgery.loading ||
                    (surgeryRecordActionType === "patientInfo" &&
                      createPatientSurgeryData?.loading)
                  }
                  startIcon={
                    ((surgeryRecordActionType === "createNewSurgery" &&
                      createSurgeryData?.loading) ||
                      (surgeryRecordActionType === "editSurgeryDetail" &&
                        updateSurgeryData?.loading) ||
                      (surgeryRecordActionType === "patientInfo" &&
                        createPatientSurgeryData?.loading)) && (
                      <CircularProgress color="white" size="20px" />
                    )
                  }
                >
                  Submit
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => handleClose()}
                  className={clsx("BtnGray", classes.submitButton)}
                >
                  Cancel
                </Button>
              </DialogActions>
            </form>
          </Box>
        </Box>
      </Dialog>
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  createSurgeryData: state.surgery.createSurgeryData,
  updateSurgeryData: state.surgery.updateSurgeryData,
  singleSurgery: state.surgery.singleSurgery,
  workingDayList: state.surgery.workingDayList,
  createPatientSurgeryData: state.patient.createPatientSurgeryData,
});
const mapDispatchToProps = (dispatch) => ({
  getStaffListAction: (payload) =>
    dispatch({ type: START_GET_STAFF_LIST, payload }),
  createSurgeryAction: (payload) =>
    dispatch({ type: START_CREATE_SURGERY, payload }),
  updateSurgeryAction: (id, payload) =>
    dispatch({ type: START_UPDATE_SURGERY, id, payload }),
  resetSurgeryState: (key, payload) =>
    dispatch({ type: RESET_SURGERY_STATE, key, payload }),
  getSingleSurgeryAction: (id) =>
    dispatch({ type: START_GET_SINGLE_SURGERY, id }),
  getWorkingDayAction: (payload) =>
    dispatch({ type: START_WORKING_DAY_LIST, payload }),
  createPatientSurgeryAction: (payload) =>
    dispatch({ type: START_CREATE_PATIENT_SURGERY, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateSurgeryDialog);
